import { ApiCreateSpaceTag } from '@/infrastructure/api-functions/api-create-space-tag.interface';
import { ApiDeleteSpaceTag } from '@/infrastructure/api-functions/api-delete-space-tag.interface';
import { ApiQuerySpaceTags } from '@/infrastructure/api-functions/api-query-space-tags.interface';
import { ApiSpaceTagServiceImpl } from '@/infrastructure/api-functions/api-space-tag-service';
import { ApiUpdateSpaceTag } from '@/infrastructure/api-functions/api-update-space-tag.interface';
import { SpaceTagsModel, SpaceTagsModelImp } from './model/space-tags-model';
import { SpaceTagRepositoryImp } from './repository/space-tag-repository';
import { CreateSpaceTagRepository, DeleteSpaceTagRepository, QuerySpaceTagsRepository, UpdateSpaceTagRepository } from './services/space-tag-repository.interface';
import { SpaceTagServiceImp } from './services/space-tag-service';
import { CreateSpaceTagService, DeleteSpaceTagService, QuerySpaceTagsService, UpdateSpaceTagService } from './services/space-tag-service.interface';
export function spaceTagModule(bind) {
    bind(SpaceTagsModel).to(SpaceTagsModelImp);
    function getTagApiService(context) {
        return context.container.get(ApiCreateSpaceTag);
    }
    bind(ApiCreateSpaceTag).to(ApiSpaceTagServiceImpl);
    bind(ApiUpdateSpaceTag).toDynamicValue(getTagApiService);
    bind(ApiQuerySpaceTags).toDynamicValue(getTagApiService);
    bind(ApiDeleteSpaceTag).toDynamicValue(getTagApiService);
    function getSpaceTagRepository(context) {
        return context.container.get(CreateSpaceTagRepository);
    }
    bind(CreateSpaceTagRepository).to(SpaceTagRepositoryImp);
    bind(UpdateSpaceTagRepository).toDynamicValue(getSpaceTagRepository);
    bind(QuerySpaceTagsRepository).toDynamicValue(getSpaceTagRepository);
    bind(DeleteSpaceTagRepository).toDynamicValue(getSpaceTagRepository);
    function getSpaceTagService(context) {
        return context.container.get(CreateSpaceTagService);
    }
    bind(CreateSpaceTagService).to(SpaceTagServiceImp);
    bind(UpdateSpaceTagService).toDynamicValue(getSpaceTagService);
    bind(QuerySpaceTagsService).toDynamicValue(getSpaceTagService);
    bind(DeleteSpaceTagService).toDynamicValue(getSpaceTagService);
}
